export default function Header({ children }) {
  return (
    <h3 className="pt-4 mb-4 md:mb-8 font-semibold text-center text-large md:text-header md:pt-8">
      {children}
    </h3>
  )
}
